import { render } from "./IconRounded.vue?vue&type=template&id=4d01387a"
import script from "./IconRounded.vue?vue&type=script&lang=js"
export * from "./IconRounded.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__